/** Combined Sagas */

import { fork } from "redux-saga/effects";
import { watchAuth } from "../auth";
import { watchUsers } from "../users";
import { watchEmployees } from "../employees";
import { watchPayer } from "../payer";
import { watchAvatar } from "../avatar";
import { watchNotes } from "../notes";
import { watchFacilities } from "../facilities";
import { watchPatients } from "../patients";
import { watchVehicles } from "../vehicles";
import { watchLegs } from "../legs";
import { watchHistory } from "../history";

export const appSaga = function* startForman() {
  yield fork(watchAuth);
  yield fork(watchUsers);
  yield fork(watchEmployees);
  yield fork(watchPayer);
  yield fork(watchAvatar);
  yield fork(watchNotes);
  yield fork(watchFacilities);
  yield fork(watchPatients);
  yield fork(watchVehicles);
  yield fork(watchLegs);
  yield fork(watchHistory);
};
